module.exports = __webpack_public_path__ + "media/src/assets/images/sale-ai_graph2-0ac48552b44cb7d7901c1b4bf598a1b0.png";